module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAAHeTXxYAAAAAXNSR0IArs4c6QAAAPBJREFUSA1jYKAFMDExuQIylwnZcDDn////DsiCYDZMOUwCRRtMEEbjlYQpGiI0I8idQN/fBFJKxLiZmZlZH6c69GBEVkhWqA1yTcj+I5rNaGpqqg1MhReI0QFU9+Ds2bOqONUaGxtfxSU5yENv1HnQiKNuQLCzszviShHg7A6SBCYbORYWFnZcCkkVB6ZTRiBgOXny5DWQXrBFNjY2gt+/f58J5HMRYaAVUA0oKI4QofYNJydn4ZEjR94ToRZVCaiMwpdpUFUjeGRFEkI78axRi4gPKzSVo0GHFiDEc+kWdCzEuwmu8jGwaGGF8wYbAwA3Zysmh2oeBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico6214.png
// module id = jrFx
// module chunks = 1